import React, { forwardRef } from 'react';
import { useLabels } from 'ws-scripts/modules/common';

import { useDrawer } from '../context/DrawerContext';

/**
 * Hamburger button — opens the drawer.
 *
 * Reads `openDrawer` from DrawerContext. No props required.
 * Accessible name comes from the `NAV_DRAWER_OPEN_LABEL` label.
 * Forwards a ref so the parent can return focus on drawer close.
 *
 * @returns {React.ReactElement}
 */
const HamburgerButton = forwardRef(
	/**
	 * @param {Object} props
	 * @param {HamburgerButtonRef} ref
	 */
	(props, ref) => {
		const labels = useLabels();
		const openLabel = labels.get('NAV_DRAWER_OPEN_LABEL');
		const { openDrawer, isOpen } = useDrawer();

		return (
			<button
				ref={ref}
				className="btn btn-link text-decoration-none ws-nav-drawer__hamburger drawer-header-icon"
				type="button"
				aria-label={openLabel}
				aria-expanded={isOpen}
				aria-controls="ws-nav-drawer-main-panel"
				onClick={openDrawer}
			>
				<i
					className="ddc-icon ddc-icon-menu ddc-icon-size-large"
					aria-hidden="true"
				/>
			</button>
		);
	}
);

HamburgerButton.displayName = 'HamburgerButton';

export default HamburgerButton;
